import type { HTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

// Karta wg systemu Workflow 3.0: radius-card 12 (`rounded-xl`), border tokenowy (zmienna motywu),
// spód `surface-card`, elewacja „Subtle" (0 1px 2px rgba(23,23,33,.06)).
const cardVariants = cva(
  'rounded-xl border border-border-secondary bg-bg-elevated shadow-[0_1px_2px_rgba(23,23,33,0.06)]',
  {
    variants: {
      padding: { none: '', sm: 'p-3', md: 'p-5', lg: 'p-6' },
    },
    defaultVariants: { padding: 'md' },
  },
);

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: NonNullable<VariantProps<typeof cardVariants>['padding']>;
}

export function Card({ children, padding = 'md', className, ...rest }: CardProps) {
  return (
    <div className={cn(cardVariants({ padding }), className)} {...rest}>
      {children}
    </div>
  );
}
